/**
 * Order transaction type.
 */
export enum OrderTransactionType {

    /** New */
    NEW = 'NEW',

    /** Replace */
    REPLACE = 'REPLACE',

    /** Cancel */
    CANCEL = 'CANCEL'
}
